import React, { useState } from 'react';
import { Check, Star, XIcon } from 'lucide-react';
import { WebinarMCStickyBar } from '../components/WebinarMCStickyBar';
export function WebinarMCAdv5Page() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  return <div className="min-h-screen bg-white font-sans text-gray-800" data-id="element-5047" data-mp="3i33fgx8k9e41">
      {/* Registration Popup */}
      {isPopupOpen && <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4" onClick={() => setIsPopupOpen(false)} data-id="element-5048" data-mp="3n2g6zvadn9cy">
          <div className="bg-white rounded-2xl p-6 w-full max-w-sm relative" onClick={e => e.stopPropagation()} data-id="element-5049" data-mp="jjd8wafbp5kh">
            <button onClick={() => setIsPopupOpen(false)} className="absolute top-3 right-3 text-gray-400 hover:text-gray-600" data-id="element-5050" data-mp="9ttq14rm1bpm">
              <XIcon className="w-6 h-6" data-id="element-5051" data-mp="xhl1y798nmqd" />
            </button>
            <div className="flex justify-center items-center w-full pt-4" data-id="element-5052" data-mp="12bfpjlrysluq">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-gpmax_cmp-mcc_pt-advertorial-5" height="500" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
            border: 'none',
            borderRadius: '15px',
            backgroundColor: 'white',
            maxWidth: '100%'
          }} data-id="element-5053" data-mp="27w2p5mi6tyrr"></iframe>
            </div>
            <p className="text-xs text-gray-500 text-center mt-3" data-id="element-5054" data-mp="2ln7g807hpiqh">
              We HATEN spam. Je e-mailadres is 100% veilig
            </p>
            <div className="flex items-center gap-3 mt-3 px-2" data-id="element-5055" data-mp="30ix7odvg2o2l">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kJ5b6tBbH8hDNt52JG84mT/Scherm%C2%ADafbeelding_2025-08-15_om_15.44.02.png" alt="Amee Buijs" className="w-9 h-9 rounded-full object-cover flex-shrink-0" data-id="element-5056" data-mp="2vnhrhf9ysg30" />
              <p className="text-xs text-gray-600 leading-snug" data-id="element-5057" data-mp="1qxckwc2w7gep">
                Dit webinar wordt gegeven door Amee Buijs, honden
                gedragsdeskundige met 10 jaar ervaring.
              </p>
            </div>
          </div>
        </div>}

      {/* Navigation */}
      <nav className="w-full border-b border-gray-200 py-4 px-6 bg-white" data-id="element-5058" data-mp="24wcably8bzbx">
        <div className="flex justify-center md:justify-between items-center" data-id="element-5059" data-mp="29v5fmr3d4k10">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-10 object-contain" data-id="element-5060" data-mp="29t2lpvz3a6r0" />
          <div className="hidden md:block" data-id="element-5061" data-mp="2nn3dg5rmithv">
            <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="500px" data-theme="light" data-id="element-5062" data-mp="2nlsbmbhqnvte">
              <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener noreferrer" data-id="element-5063" data-mp="gykyj3dmh0j9">
                Trustpilot
              </a>
            </div>
          </div>
        </div>
        <div className="md:hidden flex justify-center mt-3 w-full" data-id="element-5064" data-mp="72876c5juyro">
          <div className="trustpilot-widget" data-locale="nl-NL" data-template-id="5419b6ffb0d04a076446a9af" data-businessunit-id="65017f0060003ffc450ac45e" data-style-height="20px" data-style-width="100%" data-token="d24193a8-3943-4d9c-bcbd-f0b97f9d6fb9" data-id="element-5065" data-mp="14mkoi1340mws">
            <a href="https://nl.trustpilot.com/review/stresslessdogs.nl" target="_blank" rel="noopener" data-id="element-5066" data-mp="1nedjg11qoi75">
              Trustpilot
            </a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="max-w-6xl mx-auto px-4 py-12 md:py-20 grid md:grid-cols-12 gap-12 items-center" data-id="element-5067" data-mp="134cagiz601gs">
        <div className="md:col-span-7" data-id="element-5068" data-mp="182nkoutdgdzj">
          <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-4" data-id="element-5069" data-mp="t7zl1xank9ru">
            Gratis Online Webinar: Communiceren met je Hond
          </p>
          <h1 className="text-3xl md:text-4xl font-extrabold text-[#1a2b4a] mb-6 leading-tight" data-id="element-5070" data-mp="y8dsbd4fjfot">
            Ontdek hoe je met liefdevolle communicatie de onderlinge band met je
            hond versterkt en problemen voorkomt
          </h1>
          <button onClick={() => setIsPopupOpen(true)} className="md:hidden mx-auto block bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md mb-4" data-id="element-5071" data-mp="1c73ngn7ov5aj">
            Inschrijven webinar
          </button>
          <div className="md:hidden flex items-center justify-center gap-4 mb-8" data-id="element-5072" data-mp="29lzfisqqb77p">
            <div className="flex -space-x-3" data-id="element-5073" data-mp="3ubv4pn9qrcz1">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-5074" data-mp="3uajy7fowvr48" />
              <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-5075" data-mp="2xpd3h4xuhjr" />
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-10 h-10 rounded-full border-2 border-white" alt="User" data-id="element-5076" data-mp="36fqr68100oid" />
            </div>
            <div data-id="element-5077" data-mp="zmydoqe1i2kt">
              <p className="font-bold text-lg text-[#1a2b4a]" data-id="element-5078" data-mp="zmet11x09033">97.283+</p>
              <p className="text-xs text-gray-600" data-id="element-5079" data-mp="vmnwehksrpqn">
                Baasjes volgden al dit webinar
              </p>
            </div>
          </div>
          <p className="text-lg text-gray-700 mb-8 leading-relaxed" data-id="element-5080" data-mp="3ogd1h4t25rbu">
            Meld je aan voor het gratis webinar en leer:
          </p>

          <ul className="space-y-4 mb-8" data-id="element-5081" data-mp="29o8l3p0rgmg">
            {['Waarom je hond doet wat hij doet - en waarom je het tot nu toe verkeerd hebt begrepen', 'De taal van je hond - leer de signalen lezen van je hond zodat je ziet wat hij denkt, voelt en wilt', 'Wat angst, stress en onzekerheid werkelijk betekenen - en hoe je ze herkent', 'Waarom "ongehoorzaamheid" een mythe is - en hoe je zorgt dat jou hond weet wat je van hem wilt', 'Hoe je de wereld vanuit je hond ziet - zodat je "onverklaarbaar gedrag" ineens begrijpt', 'De 3 kernbehoeften van elke hond - en hoe deze je helpen om een rustigere blijere hond te krijgen'].map((item, i) => <li key={i} className="flex items-start" data-id="element-5082" data-mp="2qzwbczohvoc2" data-mpi={i}>
                <Check className="w-6 h-6 text-blue-500 mr-3 flex-shrink-0 mt-0.5" data-id="element-5083" data-mp="2jhg23okfzgw6" />
                <span className="text-gray-700 font-medium" data-id="element-5084" data-mp="2eillmt9y64f8">{item}</span>
              </li>)}
          </ul>

          <div className="hidden md:flex items-center gap-4" data-id="element-5085" data-mp="2agi7txzt2nqs">
            <div className="flex -space-x-3" data-id="element-5086" data-mp="2aj4elvevgz7y">
              <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-5087" data-mp="25iq3u5lvzb68" />
              <img src="https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-5088" data-mp="1vq0x1o1a6lh8" />
              <img src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=faces" className="w-12 h-12 rounded-full border-2 border-white" alt="User" data-id="element-5089" data-mp="1hsm3q87wptjz" />
            </div>
            <div data-id="element-5090" data-mp="35p1zqkp2ydyu">
              <p className="font-bold text-xl text-[#1a2b4a]" data-id="element-5091" data-mp="35pk4y6tq02iw">97.283+</p>
              <p className="text-sm text-gray-600" data-id="element-5092" data-mp="35mo5uf64z7sv">
                Baasjes volgden al dit webinar
              </p>
            </div>
          </div>
        </div>

        <div className="md:col-span-5 flex justify-center" data-id="element-5093" data-mp="2wmsqrz9gmsnk">
          <div className="p-6 rounded-3xl w-full max-w-sm mx-auto" data-id="element-5094" data-mp="2hyxxagnmok9f">
            <div className="flex justify-center items-center w-full" data-id="element-5095" data-mp="2hxmt4fq9tahs">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-gpmax_cmp-mcc_pt-advertorial-5" height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
              border: 'none',
              borderRadius: '25px',
              backgroundColor: 'white',
              maxWidth: '100%'
            }} data-id="element-5096" data-mp="2mrr214j3jsli"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* 3 Steps Section */}
      <section className="bg-gray-50 py-20" data-id="element-5097" data-mp="1fgd2z83fti5h">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-5098" data-mp="1ubt0jn387w6m">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-16" data-id="element-5099" data-mp="1uddwnh56vn6l">
            Leer de taal van je hond in drie stappen
          </h2>

          <div className="grid md:grid-cols-3 gap-12 mb-12" data-id="element-5100" data-mp="23c8zcj90yf55">
            <div className="flex flex-col items-center" data-id="element-5101" data-mp="23ao4stmpmw7a">
              <img src="https://cdn.magicpatterns.com/uploads/7G3FddFkmDX1PP48Js3VUV/agenda_icon_(1).png" alt="Agenda icoon" className="w-32 h-32 object-contain mb-6" data-id="element-5102" data-mp="1ycmq0kwbhj1m" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-5103" data-mp="28494cq3yby8l">Stap 1.</h3>
              <p className="text-gray-600" data-id="element-5104" data-mp="2m41rkbg9rwbt">
                Vul het formulier in en reserveer jouw plekje
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-5105" data-mp="2uqk1faruokee">
              <img src="https://cdn.magicpatterns.com/uploads/oxDbACMiW4Zh5cMbL7Ry7C/cursor_webinar_v3_(1).png" alt="Webinar knop icoon" className="w-32 h-32 object-contain mb-6" data-id="element-5106" data-mp="2us4wr2lzo7db" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-5107" data-mp="2g1ny1r0qnvk4">Stap 2.</h3>
              <p className="text-gray-600" data-id="element-5108" data-mp="2fzkyaf9sao27">
                Klik tegen die tijd op de link in je e-mail om direct deel te
                nemen
              </p>
            </div>
            <div className="flex flex-col items-center" data-id="element-5109" data-mp="38qusoex2o103">
              <img src="https://cdn.magicpatterns.com/uploads/swcfYXFhsSevmDxKpdEyU7/vrouw_hond_knuffel_(1).png" alt="Vrouw knuffelt hond" className="w-32 h-32 object-contain mb-6" data-id="element-5110" data-mp="33qp8fjt4tgs1" />
              <h3 className="text-xl font-bold text-[#1a2b4a] mb-3" data-id="element-5111" data-mp="1sdefqz2qhpxq">Stap 3.</h3>
              <p className="text-gray-600" data-id="element-5112" data-mp="1o9ot4f5mdifc">
                Leer in 90 minuten hoe je de taal van je hond leert spreken
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-5113" data-mp="7tj19en3ocx4">
            Inschrijven webinar
          </button>
        </div>
      </section>

      {/* Social Proof / Testimonials */}
      <section className="py-20 bg-[#fbfaf8]" data-id="element-5114" data-mp="mif6z51opduk">
        <div className="max-w-6xl mx-auto px-4 text-center" data-id="element-5115" data-mp="rhrttpsk2kx5">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-16 max-w-3xl mx-auto leading-tight" data-id="element-5116" data-mp="rg7022e2f60c">
            Duizenden baasjes gingen je voor - en zeggen allemaal hetzelfde:{' '}
            <br data-id="element-5117" data-mp="10i6jf1cjym6g" />
            <span className="italic" data-id="element-5118" data-mp="10glv3tgtzzh1">"Ik begrijp mijn hond nu pas echt."</span>
          </h2>

          {/* Videos */}
          <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-5119" data-mp="32a300pdkum83">
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-5120" data-mp="32abgssctmbok">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-5121" data-mp="9gmfmg7oku8n">
                <iframe src="https://player.vimeo.com/video/1086787571?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 2" data-id="element-5122" data-mp="ig12z6sjwoox"></iframe>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-5123" data-mp="1b4f0zmjn3l0h">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-5124" data-mp="1b2lviakrj6u2">
                <iframe src="https://player.vimeo.com/video/1086787549?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 3" data-id="element-5125" data-mp="1ps6pfqrnlqk5"></iframe>
              </div>
            </div>
            <div className="rounded-xl overflow-hidden shadow-lg bg-black" data-id="element-5126" data-mp="x4szicmdhv9j">
              <div style={{
              padding: '177.78% 0 0 0',
              position: 'relative'
            }} data-id="element-5127" data-mp="123468ehdfpnj">
                <iframe src="https://player.vimeo.com/video/1086787601?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media" style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%'
              }} title="MCC testimonial 1" data-id="element-5128" data-mp="s3n6edosw5zh"></iframe>
              </div>
            </div>
          </div>

          {/* Review Grid */}
          <div className="grid md:grid-cols-2 gap-6 mb-16 text-left" data-id="element-5129" data-mp="3texbxb08t36q">
            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-5130" data-mp="3ogm2v2hruwpk">
              <div className="flex items-center mb-4" data-id="element-5131" data-mp="3jiu71xe0aqg3">
                <div className="flex text-green-500 mr-2" data-id="element-5132" data-mp="3jkf5hy3fytj8">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-5133" data-mp="1mnod5fjakk8u" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-5134" data-mp="1q7y9f0vwxfvd">8 jul 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-5135" data-mp="1u9juh9ilp0gn">
                Hele fijne cursus. Aanrader zelfs voor de ervaren honden
                liefhebber.
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-5136" data-mp="1z2czlyhzeat9">
                Nu hebben wij altijd herplaatsers, dus we zijn wel wat gewend.
                Maar bij onze laatste herplaatser hebben we wel hulp nodig. In
                kort tijd nu al zoveel geleerd en handvaten gekregen. Ben enorm
                enthousiast over deze cursus en ik kreeg ook veel hulp
                aangeboden. Het is netjes overzichtelijk, duidelijk maar wat met
                het meeste aanspreekt is dat het zonder commando's gaat maar via
                communiceren.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-5137" data-mp="2rofo3jhahafx">
                - Nicolette
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-5138" data-mp="26zwgcfw7mi3k">
              <div className="flex items-center mb-4" data-id="element-5139" data-mp="271psgaplduiy">
                <div className="flex text-green-500 mr-2" data-id="element-5140" data-mp="2200d4ivc6up2">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-5141" data-mp="2gxke7ep445py" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-5142" data-mp="2bzr7mkjwd9p5">3 sep 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-5143" data-mp="1o9wus2zkvl4w">
                Niet goed maar uitstekend!
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-5144" data-mp="1j8hboggynop5">
                Amée is een zeer lieve vrouw met een hart voor honden en dat
                merk je zeer goed. De tips helpen echt. Ik raad iedereen met
                puppy's, jongere hondjes en alle andere leeftijden deze cursus
                aan, vooral mensen die problemen hebben met hun troetel. Zowel
                gedragsproblemen als medische problemen. Volg even de gratis
                Masterclass en je bent volledig overtuigd van de cursus en de
                mensen erachter. Heel veel liefs aan iedereen van het team.
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-5145" data-mp="329i8yg5evzyi">
                - Tine Oetzmann
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-5146" data-mp="378mgz3glnrn9">
              <div className="flex items-center mb-4" data-id="element-5147" data-mp="3uyp3l41qw5eh">
                <div className="flex text-green-500 mr-2" data-id="element-5148" data-mp="3rcl8lp4llwz">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-5149" data-mp="3lx943rcgxnp1" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-5150" data-mp="3py1dqlp95ulu">20 apr 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-5151" data-mp="2ahathj1n6tlp">
                Dit was de eerste keer dat ik een online hondencursus volgde...
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-5152" data-mp="2ehb4etpj8mo0">
                Dit was de eerste keer dat ik een online hondencursus volgde en
                ik heb er veel van opgestoken. Hoewel mijn honden zich (meestal)
                prima gedragen, wilde ik vooral leren wat ik zelf nog een beter
                kan doen ivm de communicatie. Dat is gelukt, het valt echt op
                dat omdat ik mij zelf anders opstel, mijn honden nu veel
                rustiger communiceren met andere honden. Vooral met onbekende
                honden was er toch vaak wel flink geblaf. Nu bijna niet meer,
                heerlijk, wat is wandelen toch/weer een genot. Idd: stressless!
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-5153" data-mp="3g2ts11235uby">
                - Margreet
              </p>
            </div>

            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm" data-id="element-5154" data-mp="cgbhkl4qsvlr">
              <div className="flex items-center mb-4" data-id="element-5155" data-mp="7othdzajmz1u">
                <div className="flex text-green-500 mr-2" data-id="element-5156" data-mp="7o1st8fd61l2">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-5157" data-mp="f2ucfvh3e6ri" data-mpi={i} />)}
                </div>
                <span className="text-sm text-gray-500" data-id="element-5158" data-mp="oyoyz1ofslzk">13 aug 2024</span>
              </div>
              <h4 className="font-bold text-gray-900 mb-2" data-id="element-5159" data-mp="p11qo6jzyapt">
                Ik vond het prettig mijn ervaring op te halen...
              </h4>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-5160" data-mp="xyc33v8jw5wb">
                Ik vond het prettig mijn ervaring op te halen en voorbereid te
                zijn op de puppy die ik al snel krijg. Goed gewerkt!
              </p>
              <p className="text-sm font-semibold text-gray-900 mt-4" data-id="element-5161" data-mp="17pyk687kkz6z">
                - Henne Buskermolen
              </p>
            </div>
          </div>

          <button onClick={() => setIsPopupOpen(true)} className="bg-[#f27a6b] hover:bg-[#e0695a] text-white font-bold py-4 px-10 rounded-full text-lg transition-colors shadow-md" data-id="element-5162" data-mp="1gqmq0fmt7t8s">
            Inschrijven webinar
          </button>
        </div>
      </section>

      {/* About Amee */}
      <section className="py-20 bg-white" data-id="element-5163" data-mp="2rlg1dcxpbp8v">
        <div className="max-w-5xl mx-auto px-4 grid md:grid-cols-2 gap-12 items-center" data-id="element-5164" data-mp="2vm89g2uu7o3k">
          <div data-id="element-5165" data-mp="2vol2bb24vive">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2b4a] mb-6 leading-tight" data-id="element-5166" data-mp="30l33k0y98z2z">
              Hoi, ik ben Amee en ik geef dit webinar.
            </h2>
            <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-5167" data-mp="35k60ey42zyzv">
              <p data-id="element-5168" data-mp="3ai7s27fkp6my">
                Ik ben Amee de Bruijn, hondengedragsdeskundige en oprichter van
                StresslessDogs.nl. Maar veel belangrijker: ik ben iemand die
                precies begrijpt wat je voelt als je hond je frustreert en je
                niet weet hoe je hem beter kunt begrijpen.
              </p>
              <p data-id="element-5169" data-mp="3o8t174f8627n">
                In de afgelopen jaren heb ik meer dan 15.000 hondenbaasjes en
                hun honden mogen begeleiden. Niet om hen te 'trainen' in de
                traditionele zin, maar om hen te helpen wat ik zelf ook ontdekt
                heb: dat echte verandering begint met communicatie, niet met
                commando's.
              </p>
              <p data-id="element-5170" data-mp="3tgj1rcoq4rr3">
                Wat ik in al die jaren heb gezien, is dat de meeste frustratie
                niet voortkomt uit een 'slecht' hond of een 'falende' baas. Het
                komt voort uit onbegrip. Uit het feit dat baasjes en honden
                letterlijk twee verschillende talen spreken. Zodra je die taal
                van je hond leert, verdwijnt de frustratie. De strijd maakt
                plaats voor samenwerking. En de band wordt onverwoestbaar.
              </p>
              <p data-id="element-5171" data-mp="c6umc7jv6m2u">
                Daarom werk ik uitsluitend met methodes die gebaseerd zijn op
                vertrouwen, veiligheid, wederzijds respect en echte
                communicatie. Geen dwang, geen pijn, geen angst, geen straf.
                Alleen liefde en begrip. Want dat is wat zowel jij als je hond
                verdienen.
              </p>
              <p data-id="element-5172" data-mp="336a64q03xxcg">
                Dit webinar is mijn manier om dit geheim met zoveel mogelijk
                hondenbaasjes te delen. Omdat ik geloof dat elke hond en elke
                mens de kans verdient om elkaar écht te begrijpen.
              </p>
            </div>
          </div>
          <div className="rounded-2xl overflow-hidden shadow-xl" data-id="element-5173" data-mp="2fgfvmf39gkvd">
            <img src="https://cdn.magicpatterns.com/uploads/vXmyJc5cCVvbLnBaXGCixn/682f298cbb713_AmeemetSophietje1.png" alt="Amee met Sophietje" className="w-full h-auto object-cover" data-id="element-5174" data-mp="2fi96k6kwpr96" />
          </div>
        </div>
      </section>

      {/* Bottom Registration */}
      <section className="py-20 bg-gray-50" data-id="element-5175" data-mp="3qlyyquj5uc7">
        <div className="max-w-md mx-auto px-4" data-id="element-5176" data-mp="3rx2qqnz723b">
          <div className="p-6 rounded-3xl w-full" data-id="element-5177" data-mp="8pq7df9mro1h">
            <div className="flex justify-center items-center" data-id="element-5178" data-mp="8of55jvu2och">
              <iframe src="https://app.webinargeek.com/embed/5986c9f7-67ed-4239-8b16-51dc19c90478?cst=src-gpmax_cmp-mcc_pt-advertorial-5" height="550" width="330" title="Webinar Communiceren Met Je Hond Stressless Dogs" style={{
              border: 'none',
              borderRadius: '25px',
              backgroundColor: 'white'
            }} data-id="element-5179" data-mp="1t7hg0c7t1rz6"></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-12" data-id="element-5180" data-mp="27wdo299v34zs">
        <div className="max-w-6xl mx-auto px-4 flex flex-col items-center text-center" data-id="element-5181" data-mp="2lvdd3i1adlwh">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs" className="h-12 object-contain mb-6" data-id="element-5182" data-mp="2gx2397azrbe9" />
          <p className="font-semibold text-[#1a2b4a] mb-2" data-id="element-5183" data-mp="ml56qzxozfcc">
            Voor liefdevolle hondenbaasjes
          </p>
          <a href="mailto:amee@stresslessdogs.nl" className="text-blue-600 hover:underline mb-8" data-id="element-5184" data-mp="o2kfodlm435z">
            amee@stresslessdogs.nl
          </a>

          <div className="text-xs text-gray-500 max-w-3xl leading-relaxed" data-id="element-5185" data-mp="xzf8cfv7f9cc">
            <p className="mb-2" data-id="element-5186" data-mp="12wfgcwbm6m63">
              © 2025 Stressless Dogs. Alle rechten voorbehouden.
            </p>
            <p data-id="element-5187" data-mp="5bjgbogky5lw">
              Deze website maakt gebruik van cookies en vergelijkbare
              technologieën voor analytische en advertentiedoeleinden. Deze
              pagina is een advertorial voor Stressless Dogs. Stressless Dogs is
              een onafhankelijk bedrijf en is op geen enkele wijze verbonden aan
              of onderdeel van Meta (voorheen Facebook). Deze advertentie wordt
              getoond via het Meta advertentieplatform, maar Meta is niet
              verantwoordelijk voor de inhoud of diensten aangeboden door
              Stressless Dogs.
            </p>
          </div>
        </div>
      </footer>
      <WebinarMCStickyBar onClickCTA={() => setIsPopupOpen(true)} data-id="element-5188" data-mp="20r9mbao4bs1u" />
    </div>;
}